import { render, staticRenderFns } from "./TheSidebarMenu.vue?vue&type=template&id=881e0b8a&scoped=true&"
import script from "./TheSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./TheSidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheSidebarMenu.vue?vue&type=style&index=0&id=881e0b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881e0b8a",
  null
  
)

export default component.exports